<template>
	<div class="content">
		<div class="row">
			<div class="col-12">
				<div class="row">
					<div class="col-2"><h5>Editar Cliente</h5></div>
					<div class="col-8 text-center"><h5>{{ mensaje }}</h5></div>
					<div class="col-2 text-right">
						<b-button size="sm" variant="primary" @click="guardar">Guardar</b-button>&nbsp;
						<b-button size="sm" variant="secondary" @click="cerrar">Cerrar</b-button>
					</div>
				</div>
				<hr style="margin-top: 10px; margin-bottom: 5px" />
			</div>
		</div>
		<div class="row data">
			<div class="col-12 formulario">
				<b-form id="editarClienteForm">
					<div class="row">
						<div class="col-6">
							<div class="row">
								<div class="col-12"><b>Datos Empresa</b> <hr class="linea" /></div>
							</div>
							<p class="separador" />
							<div class="row">
								<div class="col-4">
									<small>R.U.T.</small>
									<b-input id="CLIENT_TAX_CODE" name="CLIENT_TAX_CODE" :value="tcliente._source.CLIENT_TAX_CODE" size="sm" placeholder="12345678-9" :state="validado.CLIENT_TAX_CODE" required upper />
								</div>
								<div class="col-8">
									<small>Razón Social</small>
									<b-input id="CLIENT_NAME" name="CLIENT_NAME" :value="tcliente._source.CLIENT_NAME" size="sm" :state="validado.CLIENT_NAME" required />
								</div>
							</div>
							<p class="separador" />
							<div class="row">
								<div class="col-12">
									<small>Grupo Económico</small>
									<b-input id="GRUPO_ECONOMICO" name="GRUPO_ECONOMICO" :value="tcliente._source.GRUPO_ECONOMICO" size="sm" />
								</div>
							</div>
							<p class="separador" />
							<div class="row">
								<div class="col-6">
									<small>Client ID</small>
									<b-input id="CLIENT_ID" name="CLIENT_ID" :value="tcliente._source.CLIENT_ID" size="sm" :state="validado.CLIENT_ID" disabled />
								</div>
								<div class="col-6">
									<small>Client ID Madre</small>
									<b-input id="CLIENT_ID_MADRE" name="CLIENT_ID_MADRE" :value="tcliente._source.CLIENT_ID_MADRE" size="sm" :state="validado.CLIENT_ID_MADRE" disabled />
								</div>
							</div>
							<p class="separador" />
							<div class="row">
								<div class="col-12">
									<small>Giro</small>
									<b-select id="GIRO" name="GIRO" size="sm" v-model="tcliente._source.GIRO" :options="getGiros" value-field="id" text-field="tag" :state="validado.GIRO" required />
								</div>
							</div>
							<p class="separador" />
							<div class="row">
								<div class="col-4">
									<small>Last Event Type</small>
									<b-select id="LAST_EVENT_TYPE" name="LAST_EVENT_TYPE" size="sm" v-model="tcliente._source.LAST_EVENT_TYPE" :options="getLastEventType" value-field="id" text-field="tag" />
								</div>
								<div class="col-4">
									<small>Categoría</small>
									<b-select id="CATEGORIA" name="CATEGORIA" size="sm" v-model="tcliente._source.CATEGORIA" :options="getCategorias" value-field="id" text-field="tag" />
								</div>
								<div class="col-4">
									<small>Billing Period</small>
									<b-select id="BILLING_PERIOD" name="BILLING_PERIOD" size="sm" v-model="tcliente._source.BILLING_PERIOD" :options="getBillingPeriod" value-field="id" text-field="tag" :state="validado.BILLING_PERIOD" required />
								</div>
							</div>
							<p class="separador" />
							<div class="row">
								<div class="col-4">
									<small>Size</small>
									<b-select id="SIZE" name="SIZE" size="sm" v-model="tcliente._source.SIZE" :options="getSize" value-field="id" text-field="tag" />
								</div>
								<div class="col-8">
									<small>Sector</small>
									<b-select id="SECTOR" name="SECTOR" size="sm" v-model="tcliente._source.SECTOR" :options="getSector" value-field="id" text-field="tag" />
								</div>
							</div>
							<p class="separador" />
							<div class="row">
								<div class="col-6">
									<small>City</small>
									<b-input id="CITY" name="CITY" :value="tcliente._source.CITY" size="sm" />
								</div>
								<div class="col-6">
									<small>County</small>
									<b-input id="COUNTY" name="COUNTY" :value="tcliente._source.COUNTY" size="sm" />
								</div>
							</div>
							<p class="separador" />
							<div class="row">
								<div class="col-4">
									<small>Registered Users</small>
									<b-input id="REGISTERED_USERS" name="REGISTERED_USERS" :value="tcliente._source.REGISTERED_USERS" size="sm" />
								</div>
								<div class="col-4">
									<small>Potential Users</small>
									<b-input id="POTENTIAL_USERS" name="POTENTIAL_USERS" :value="tcliente._source.POTENTIAL_USERS" size="sm" />
								</div>
								<div class="col-4">
									<small>Deal Value</small>
									<b-input id="DEAL_VALUE" name="DEAL_VALUE" :value="tcliente._source.DEAL_VALUE" size="sm" />
								</div>
							</div>
						</div>
						<div class="col-6">
							<div class="row">
								<div class="col-12"><b>Datos de Facturación</b> <hr class="linea" /></div>
							</div>
							<p class="separador" />
							<div class="row">
								<div class="col-6">
									<small>Correo</small>
									<b-input id="CORREOS_FAC" name="CORREOS_FAC" :value="tcliente._source.CORREOS_FAC" size="sm" :state="validado.CORREOS_FAC" required />
								</div>
								<div class="col-6">
									<small>Dirección</small>
									<b-input id="CLIENT_ADDRESS" name="CLIENT_ADDRESS" :value="tcliente._source.CLIENT_ADDRESS" size="sm" :state="validado.CLIENT_ADDRESS" required />
								</div>
							</div>
							<p class="separador" />
							<div class="row">
								<div class="col-6">
									<small>Comuna</small>
									<b-select id="CLIENT_CITY" name="CLIENT_CITY" size="sm" v-model="tcliente._source.CLIENT_CITY" :options="getComunas" value-field="id" text-field="tag" :state="validado.CLIENT_CITY" required />
								</div>
								<div class="col-6">
									<small>Ciudad</small>
									<b-input id="CIUDAD_FAC" name="CIUDAD_FAC" :value="tcliente._source.CIUDAD_FAC" size="sm" :state="validado.CIUDAD_FAC" required />
								</div>
							</div>
							<p class="separador" />
							<div class="row">
								<div class="col-8">
									<small>Detalle CC</small>
									<b-input id="DETALLE_CC_FACTURACION" name="DETALLE_CC_FACTURACION" :value="tcliente._source.DETALLE_CC_FACTURACION" size="sm" />
								</div>
								<div class="col-4">
									<small>Recurrente</small>
									<b-select id="RECURRENTE" name="RECURRENTE" size="sm" v-model="tcliente._source.RECURRENTE" :options="getSioNo" value-field="id" text-field="tag" />
								</div>
							</div>
							<p class="separador" />
							<div class="row">
								<div class="col-4">
									<small>N. OC</small>
									<b-input id="N_OC" name="N_OC" :value="tcliente._source.N_OC" size="sm" />
								</div>
								<div class="col-8">
									<small>Vencimiento OC</small>
									<b-input-group size="sm">
										<date-picker id="VENCIMIENTO_OC" name="VENCIMIENTO_OC" :value="tcliente._source.VENCIMIENTO_OC"
											:config="{ format: 'MM-DD-YYYY', locale: 'es' }" placeholder="Ingresar Fecha"></date-picker>
									</b-input-group>
								</div>
							</div>
							<div class="row">&nbsp;</div>
							<div class="row">
								<div class="col-12"><b>Detalles de Facturación</b> <hr class="linea" /></div>
							</div>
							<p class="separador" />
							<div class="row">
								<div class="col-6">
									<small>Especial</small>
									<b-select id="ESPECIAL" name="ESPECIAL" size="sm" v-model="tcliente._source.ESPECIAL" :options="getSioNo" value-field="id" text-field="tag" required />
								</div>
								<div class="col-6">
									<small>Centro Costo</small>
									<b-select id="CENTRO_COSTO" name="CENTRO_COSTO" size="sm" v-model="tcliente._source.CENTRO_COSTO" :options="getSioNo" value-field="id" text-field="tag" :disabled="tcliente._source.ESPECIAL == 'NO'" required />
								</div>
							</div>
							<p class="separador" />
							<div class="row">
								<div class="col-4">
									<small>Orden Compra</small>
									<b-select id="ORDEN_COMPRA" name="ORDEN_COMPRA" size="sm" v-model="tcliente._source.ORDEN_COMPRA" :options="getSioNo" value-field="id" text-field="tag" :disabled="tcliente._source.ESPECIAL == 'NO'" :state="validado.ORDEN_COMPRA" required />
								</div>
								<div class="col-4">
									<small>Desglose</small>
									<b-select id="DESGLOSE" name="DESGLOSE" size="sm" v-model="tcliente._source.DESGLOSE" :options="getSioNo" value-field="id" text-field="tag" :disabled="tcliente._source.ESPECIAL == 'NO'" :state="validado.DESGLOSE" required />
								</div>
								<div class="col-4">
									<small>HES</small>
									<b-select id="HES" name="HES" size="sm" v-model="tcliente._source.HES" :options="getSioNo" value-field="id" text-field="tag" :disabled="tcliente._source.ESPECIAL == 'NO'" :state="validado.HES" required />
								</div>
							</div>
							<p class="separador" />
							<div class="row">
								<div class="col-6">
									<small>Método Pago</small>
									<b-select id="METODO_PAGO" name="METODO_PAGO" size="sm" v-model="tcliente._source.METODO_PAGO" :options="getMetodoPago" value-field="id" text-field="tag" :state="validado.METODO_PAGO" required />
								</div>
								<div class="col-6">
									<small>Payment Terms</small>
									<b-select id="PAYMENT_TERMS" name="PAYMENT_TERMS" size="sm" v-model="tcliente._source.PAYMENT_TERMS" :options="getPaymentTerms" value-field="id" text-field="tag" :state="validado.PAYMENT_TERMS" required />
								</div>
							</div>
						</div>
					</div>
					<div class="row">&nbsp;</div>
					<div class="row">
						<div class="col-12">
							<div class="row">
								<div class="col-12"><b>Contactos</b> <hr class="linea" /></div>
							</div>
							<p class="separador" />
							<div class="row">
								<div class="col-3">
									<small>Nombre Admin</small>
									<b-input id="NOMBRE_ADMIN" name="NOMBRE_ADMIN" :value="tcliente._source.NOMBRE_ADMIN" size="sm" />
								</div>
								<div class="col-3">
									<small>Correo Admin</small>
									<b-input id="CORREO_ADMIN" name="CORREO_ADMIN" :value="tcliente._source.CORREO_ADMIN" size="sm" />
								</div>
								<div class="col-3">
									<small>Teléfono Admin 1</small>
									<b-input id="TELEFONO_ADMIN" name="TELEFONO_ADMIN" :value="tcliente._source.TELEFONO_ADMIN" size="sm" />
								</div>
								<div class="col-3">
									<small>Teléfono Admin 2</small>
									<b-input id="TELEFONO_ADMIN2" name="TELEFONO_ADMIN2" :value="tcliente._source.TELEFONO_ADMIN2" size="sm" />
								</div>
							</div>
							<p class="separador" />
							<div class="row">
								<div class="col-3">
									<small>Nombre Cobranza</small>
									<b-input id="NOMBRE_COB" name="NOMBRE_COB" :value="tcliente._source.NOMBRE_COB" size="sm" />
								</div>
								<div class="col-3">
									<small>Correo Cobranza 1</small>
									<b-input id="CORREO_COB" name="CORREO_COB" :value="tcliente._source.CORREO_COB" size="sm" />
								</div>
								<div class="col-3">
									<small>Teléfono Cobranza 1</small>
									<b-input id="TELEFONO_COB" name="TELEFONO_COB" :value="tcliente._source.TELEFONO_COB" size="sm" />
								</div>
								<div class="col-3">
									<small>Teléfono Cobranza 2</small>
									<b-input id="TELEFONO_COB2" name="TELEFONO_COB2" :value="tcliente._source.TELEFONO_COB2" size="sm" />
								</div>
							</div>
						</div>
					</div>
					<div class="row">&nbsp;</div>
					<div class="row">
						<div class="col-12"><b>Responsables Cabify</b> <hr class="linea" /></div>
					</div>
					<p class="separador" />
					<div class="row">
						<div class="col-4">
							<small>Hunter Rep.</small>
							<b-select id="SALES_REP" name="SALES_REP" size="sm" v-model="tcliente._source.SALES_REP" :options="getHunterRep" value-field="id" text-field="tag" />
						</div>
						<div class="col-4">
							<small>Farmer Rep.</small>
							<b-select id="SOPORTE" name="SOPORTE" size="sm" v-model="tcliente._source.SOPORTE" :options="getFarmerRep" value-field="id" text-field="tag" />
						</div>
						<div class="col-2">
							<small>Collection</small>
							<b-select id="COLLECTION" name="COLLECTION" size="sm" v-model="tcliente._source.COLLECTION" :options="getCollection" value-field="id" text-field="tag" :state="validado.COLLECTION" required />
						</div>
					</div>
					<p class="separador" />
				</b-form>
			</div>
		</div>
	</div>
</template>
<script lang="ts">

	import axios from "axios"
	import moment from "moment"
	import $ from "jquery"
	import listas from "./listas.json"
	import ValidaRut from "./ValidaRut.js"


	export default {
		name: "Editar",
		props: {
			cliente: Object, // Objeto con la informacion del cliente 
			onCerrar: Function,
		},
		data() {
			return {
				tcliente: this.cliente,
				mostrar: true, // Flag que controla si se muestra o no la ventana
				mensaje: "",
				validado: {},
			}
		},
		computed: {

			getGiros() { return listas.giros },
			getLastEventType() { return listas.last_event_type },
			getCategorias() { return listas.categorias },
			getBillingPeriod() { return listas.billing_period },
			getSize() { return listas.size },
			getSector() { return listas.sector },
			getComunas() { return listas.comunas },
			getSioNo() { return listas.siono },
			getMetodoPago() { return listas.metodo_pago },
			getPaymentTerms() { return listas.payment_terms },
			getHunterRep() { return listas.hunter_rep },
			getFarmerRep() { return listas.farmer_rep },
			getCollection() { return listas.collection },

		},
		methods: {

			// Se asume que al presionar Refacturar, se cierra la ventana
			guardar() {

				var form = $("#editarClienteForm")[0]
				var data = new FormData(form)
				var seguir = true 
				var datos = this.tcliente._source

				var that = this
				data.forEach(function(value, key, o) {

					var e = $("#" + key).attr("required")
					if (e != undefined)
					{
						if (value == "") {

							that.$set(that.validado, key, false)
							seguir = false
						} else
							that.$set(that.validado, key, true)
					}

					// Pasamos a mayusculas el valor del campo
					var u = $("#" + key).attr("upper")
					if (u != undefined)
						value = value.toString().toUpperCase()

					datos[key] = value
				})

				var valido = ValidaRut($("#CLIENT_TAX_CODE").val())
				if (!valido) {

					this.$set(this.validado, "CLIENT_TAX_CODE", false)
					seguir = false
				} else
					this.$set(this.validado, "CLIENT_TAX_CODE", true)

				if (!seguir)
					return

				datos["ES_idCli"] = this.tcliente._id
				datos["USUARIO_ACTUALIZACION"] = this.$usuario
				datos["FECHA_ACTUALIZACION"] = moment().format("YYYY-MM-DD HH:mm:ss")
				datos["@timestamp"] = moment(datos.F_CREACION_BS).format("YYYY-MM-DDTHH:mm:ss")

				var request = {
					"usuario": this.$usuario,
					"destino": this.$env,
					"tx": "man0",
					"proceso": "updCli",
					"clientes": [ datos ],
				}

				// mostramos la imagen cargando
				window.event.$emit("mostrar-cargando", true)

				axios.post("/face", request, { headers: { "Content-Type": "text/plain" } }).then(response => {

					this.mensaje = response.data

					// ocultamos la imagen cargando
					window.event.$emit("mostrar-cargando", false)
				}).catch(ex => {

					this.mensaje = ex.message

					// ocultamos la imagen cargando
					window.event.$emit("mostrar-cargando", false)
				})
			},

			cerrar() {

				if (this.onCerrar)
					this.onCerrar()
			},
		}
	}
</script>
<style scoped>

	.content {
		height: 485px;
		/*margin: 10px;*/
		border: 1px solid lightgray;
		background-color: white;
		padding: 10px 10px 10px 10px;
	}

	.data {
		/*width: 100%;*/
		margin-top: 10px;
		padding-bottom: 10px;
		height: Calc(100% - 50px);
		overflow: auto;
	}

	.formulario {
		width: 100%;
		height: auto;
		overflow: auto;
		font-size: 14px;
	}

	.linea {
		margin-top: 3px;
		margin-bottom: 5px;
	}

	.separador {
		margin-bottom: 8px;
	}

</style>
